import { Component, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, LoadingController, ToastController, ModalOptions, Modal } from 'ionic-angular';
import { Sadhona } from '../../providers/sadhona';
import { MenteeGroupData } from '../../providers/mentee-group-data'
import { Storage } from '@ionic/storage';
/**
 * Generated class for the ViewReadSadhanaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-view-read-sadhana',
  templateUrl: 'view-read-sadhana.html',
})
export class ViewReadSadhanaPage {
  menteecomment: any = '';
  mentorcomment: any = '';
  dayArray: any = []
  sadhonaDataArray: any
  myDate: any
  // myDate:any= new Date('YYYY-MM')
  nofday: number;
  userid: any
  item: any
  isApproved = true
  currentUserId: any
  ismentor = false
  mentorname: any;
  constructor(public navCtrl: NavController, private zone: NgZone, public alertCtrl: AlertController,
    public navParams: NavParams, private sadhona: Sadhona, public loadingCtrl: LoadingController, private toastCtrl: ToastController,
    private modal: ModalController, private menteeGroupData: MenteeGroupData, private storage: Storage) {
    this.storage.get('userId').then((value) => {
      this.currentUserId = value
    });
    this.myDate = this.navParams.get('year') + '-' + this.navParams.get('month')
    this.userid = this.navParams.get('userid')
    let sequencenumber = this.navParams.get('sequencenumber')
    this.item = this.navParams.get('item')
    this.mentorname = this.navParams.get('mentorname')
    if (sequencenumber && this.userid) {
      this.getSadhonaSheet()
      this.getComment(sequencenumber)
      this.getMentorId(this.userid)
    }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewReadSadhanaPage');
  }

  getMonthDate() {
    this.dayArray = []
    for (let i = 1; i <= this.nofday; i++) { // n is array.length

      this.dayArray.push({ day: i })
    }
  }

  convertText(value) {
    if (typeof (value) === "boolean" && value == true) {
      return 'checkbox-outline'
    } else if (typeof (value) === "boolean" && value == false) {
      return ''
    } else {
      return value
    }
  }

  getSadhonaSheet() {
    this.presentLoadingDefault('Loading your records ')
    let daySplit = this.myDate.split('-')
    this.nofday = this.daysInMonth(daySplit[1], daySplit[0])
    let fromdate = this.myDate + '-01'
    let todate = this.myDate + '-' + this.nofday
    this.getMonthDate()
    this.sadhona.getMenteeSadhanaSheet(fromdate, todate, this.userid).subscribe(
      res => {
        this.zone.run(() => {
          this.sadhonaDataArray = res['data']
          this.sadhonaDataArray.map(titem => {
            if (titem.databasename == "delayinentering") {
              titem.item.map(sitem => {
                if (sitem.hasOwnProperty('item') && sitem.item > 8) {
                  sitem.color = 'red'
                } else if (sitem.hasOwnProperty('item') && sitem.item > 3 && sitem.item < 8) {
                  sitem.color = 'orange'
                } else {
                  sitem.color = 'green'
                }
              })
            } else {
              titem.item.map(sitem => {
                sitem.color = ''
              })
            }
          })
        });
      },
      err => {
        this.presentAlert('Error', 'something went wrong, try again')
      }
    )
  }

  getComment(sequencenumber) {
    this.sadhona.getComments(sequencenumber).subscribe(
      res => {
        if (res['data'].length > 1) {
          this.menteecomment = res['data'][0].comments
          this.mentorcomment = res['data'][1].comments
        } else {
          this.menteecomment = res['data'][0].comments
          this.mentorcomment = null
        }

      }
    )
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();

  }

  presentLoadingDefault(message) {
    let loading = this.loadingCtrl.create({
      content: message
    });

    loading.present();

    setTimeout(() => {
      loading.dismiss();
    }, 2000);
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

  approveSadhana(item) {
    const myModalOptions: ModalOptions = {
      enableBackdropDismiss: false
    };
    let date = item.sadhanayear + '-' + item.sadhanamonth
    const myModal: Modal = this.modal.create('CommentPage', { data: date, type: 'Approve' }, myModalOptions);

    myModal.present();

    myModal.onDidDismiss((data) => {
      if (data.success) {
        this.submitApproveSadhona(item, data.comment)
      }
    });
  }

  submitApproveSadhona(item, comment) {
    item.comment = comment
    this.sadhona.approveSadhana(item).subscribe(
      res => {
        this.presentToast('Sadhana has been approved successfully')
        this.isApproved = true
      },
      err => {
        this.presentAlert('error', 'Something went wrong ,try again')
      }
    )
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  getMentorId(userid) {
    this.menteeGroupData.getMentorByMentee(userid).subscribe(
      res => {
        console.log(res)
        if (res['data'].length > 0) {
          console.log(this.currentUserId)
          const mentors: any = res["data"].map(p => Number(p.mentoruserid));
          if (mentors.includes(Number(this.currentUserId))) {
            this.isApproved = false
            this.ismentor = true
          }
        }
      },
      error => {
        this.presentAlert('Alert', 'Something went wrong, try again')
      }
    )
  }

  sendEmail() {
    let data = this.myDate.split('-')
    let year = data[0]
    let month = data[1]
    let submitData = { year: year, month: month }
    this.sadhona.sendSadhanaEmail(submitData).subscribe(
      res => {
        this.presentToast('Email has been sent successfully')
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-read-sadhana/view-read-sadhana.ts